// src/Services/plan.ts
//
// Regras de exibição dos planos que valem para mais de uma tela.

/**
 * Planos cobrados por TEMPO DE VEICULAÇÃO, e não por mês.
 *
 * Pulse e Wave compram um período de banner na vitrine (15 e 30 dias).
 * Mostrar "/mês" ao lado do preço deles dava a entender assinatura mensal
 * recorrente, que não é o que a pessoa contrata.
 *
 * A checagem é pelo NOME vindo do banco — mesmo critério que o
 * resolvePlanType de cada tela usa — porque é o nome que chega junto do
 * preço em todos os lugares onde o valor aparece.
 */
export const planoPorVeiculacao = (nome?: string | null): boolean => {
  const n = (nome ?? "").toLowerCase();
  return n.includes("pulse") || n.includes("wave");
};

/**
 * Sufixo de periodicidade para colar no preço já formatado.
 * String vazia nos planos por veiculação.
 */
export const sufixoDePeriodo = (nome?: string | null): string =>
  planoPorVeiculacao(nome) ? "" : "/mês";